import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import cardTopup01 from "@/assets/images/help/card-topup-01.png";
import cardTopup02 from "@/assets/images/help/card-topup-02.png";

export default function HelpCardTopup() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            Top Up Your Fellas Card
          </h1>
        </div>

        {/* Introduction */}
        <div className="space-y-9">
          {/* First Section */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70">
              After registering your card, you need to top it up to use your
              Fellas Card. Topping up ensures your card has a balance, allowing
              you to make payments, transfers, and use all features.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 1: Start Top-Up</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Click the "Top-Up" button to go to the top-up screen.
            </p>
            <div className="rounded-[10px] overflow-hidden">
              <img
                src={cardTopup01}
                alt="Card Top-up Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 2: Enter Amount and Complete
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Enter the amount you want to top up and click the "Top-Up" button.
              {"\n\n"}Once completed, the top-up will be reflected in your card
              balance.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={cardTopup02}
                alt="Card Top-up Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/11")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Guide to Setting Your PIN</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
